import { PiniaVuePlugin } from 'pinia'
// eslint-disable-next-line import/no-extraneous-dependencies
import { createLocalVue, mount } from '@vue/test-utils'
// eslint-disable-next-line import/no-extraneous-dependencies
import { createTestingPinia } from '@pinia/testing'
import { getComponentConfig } from 'www/test/functions'
import AppointmentButton from 'src/components/pages/appointment/vrach/new/components/DoctorAppointmentForm/components/PaymentInfo/components/AppointmentSubmitV2.vue'
import useFamilyProfilesStore from 'www/vue_components/common/FamilyProfiles/stores/useFamilyProfilesStore'
import {
  useAppointmentDataStore,
} from 'www/vue_components/common/AppointmentPage/stores'
import { APPOINTMENT_PLACE_TYPES } from 'www/vue_components/common/AppointmentPage/constants'

const localVue = createLocalVue()

localVue.use(PiniaVuePlugin)

const localPinia = createTestingPinia({
  initialState: {
    appointmentDataStore: {
      appointmentRegistrationTypes: {
        isDirect: true,
      },
    },
  },
})
const familyProfilesStore = useFamilyProfilesStore(localPinia)
const appointmentDataStore = useAppointmentDataStore(localPinia)

// @ts-ignore
const wrapper = mount(AppointmentButton, getComponentConfig({
  localVue,
  pinia: localPinia,
}))
const btn = wrapper.findComponent({ name: 'VBtn' })

describe('Когда isFamilyRequestDone = false', () => {
  beforeAll(() => {
    familyProfilesStore.isFamilyRequestDone = false
  })
  test('Тогда кнопка заблокирована', () => {
    // @ts-ignore
    expect(btn.vm.disabled).toBe(true)
  })
})

describe('Когда isFamilyRequestDone = true', () => {
  beforeAll(() => {
    familyProfilesStore.isFamilyRequestDone = true
  })
  test('Тогда кнопка разблокирована', () => {
    // @ts-ignore
    expect(btn.vm.disabled).toBe(false)
  })
})

describe('Когда нажимается VBtn', () => {
  beforeAll(() => {
    familyProfilesStore.isFamilyRequestDone = true
  })
  test('Тогда обрабатывается нажатие', () => {
    btn.trigger('click')
    expect(wrapper.emitted()).toHaveProperty('click:appointment')
  })
})

describe('Когда меняется appointmentPlaceTypes.isTelemed', () => {
  beforeAll(() => {
    appointmentDataStore.initAdditionalData.placeType = APPOINTMENT_PLACE_TYPES.telemed
  })
  test('Тогда меняется текст кнопки', async () => {
    const btnText = btn.text()

    appointmentDataStore.initAdditionalData.placeType = ''

    await Promise.resolve()

    expect(btnText).not.toBe(btn.text())
  })
})

describe('Когда appointmentPlaceTypes.isTelemed = true', () => {
  beforeAll(() => {
    appointmentDataStore.initAdditionalData.placeType = APPOINTMENT_PLACE_TYPES.telemed
  })
  test('Тогда VIcon не выводится', () => {
    const icon = wrapper.findComponent({ name: 'VIcon' })

    expect(icon.exists()).toBe(false)
  })
})
